import useApiMutation from '@src/hooks/useApiMutation';
import { CreateDeviceDto } from '@src/types/Device';

export default () => {
  const createDevice = useApiMutation<CreateDeviceDto, void>({
    apiPath: '/devices',
    method: 'POST',
    useV2API: true,
  });

  return {
    createDevice,
  };
};
